import type { MapConfig } from '../../api/types'
import { useSettings, useTrip } from '../../hooks/queries'
import { gemerkteQuelle } from '../../lib/kartenquelle'

/** Dieselben Werte wie `MapSources::AUSWAHL['standard']` — das letzte Netz. */
export const VORGABE: MapConfig = {
  tile_url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution: '&copy; OpenStreetMap-Mitwirkende',
  max_zoom: 19,
} as MapConfig

/**
 * Welche Karte das Buch zeichnet — **an einer Stelle.**
 *
 * Die Übersichtskarte hatte diese drei Zeilen bei sich stehen. Mit den kleinen
 * Ausschnitten an jedem Punkt wären es zwei Kopien geworden, und eine davon
 * hätte irgendwann eine andere Quelle gezeigt als die andere — auf derselben
 * Seite.
 *
 * Die Reihenfolge ist die der ganzen Anwendung: was die Verwaltung eingestellt
 * hat, sonst was zuletzt galt, sonst die Vorgabe. Ein Buch, das gar keine
 * Karte zeigt, weil die Einstellungen noch nicht da sind, wäre die schlechtere
 * Antwort.
 */
export function useBuchquelle(tripId: number): MapConfig {
  // **Die Karte der Reise zuerst** (#50): das Buch und das Standbild der
  // Tageskarte zeigen dasselbe Kartenbild wie die Reiseseite. Die Einstellungen
  // tragen den Augenblick, bevor die Reise geladen ist.
  const reise = useTrip(tripId).data
  const einstellungen = useSettings().data
  return reise?.map ?? einstellungen?.map ?? gemerkteQuelle() ?? VORGABE
}
